export class DefaultConfiguration {
  series?: string
  model?: string
  isThreeSidedFrame?: boolean
}
